import React, { useState, useEffect } from "react";
import "./AdminWorkers.css"; 
import bfLogo from "../assets/bf_logo.png"; 
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Būtina vertimams
import { ArrowLeft, RefreshCw, Trash2, Info } from "lucide-react";
import { auth, db } from "../firebase";
import { 
  collection, query, where, onSnapshot, updateDoc, deleteDoc, doc, getDoc, getCountFromServer 
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import WorkerInfoModal from "../components/WorkerInfoModal"; 

const PLAN_LIMITS = {
  active_basis: 10,
  active_growth: 30,
  active_pro: 50,
  enterprise: 999
};

export default function AdminWorkerArchive() {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Pajungiame vertimus
  const [archivedWorkers, setArchivedWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    let unsubscribeSnapshot = () => {};
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const uData = userSnap.data();
          setUserData(uData);
          const masterId = uData.belongsTo || user.uid;
          
          const q = query(
            collection(db, "workers"), 
            where("adminId", "==", masterId), 
            where("archived", "==", true)
          );
          
          unsubscribeSnapshot = onSnapshot(q, (snap) => {
            setArchivedWorkers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            setLoading(false);
          });
        }
      } else navigate("/admin/login");
    });
    return () => { unsubscribeAuth(); unsubscribeSnapshot(); };
  }, [navigate]);

  // --- ATSTATYTI Į DARBĄ ---
  const handleRestore = async (worker) => {
    if (!userData) return;
    const masterId = userData.belongsTo || auth.currentUser.uid;

    try {
        const coll = collection(db, "workers");
        const qActive = query(coll, where("adminId", "==", masterId), where("archived", "==", false));
        const snapshot = await getCountFromServer(qActive);
        const currentActive = snapshot.data().count;
        
        const maxLimit = userData.workerLimit || PLAN_LIMITS[userData.subscriptionStatus?.toLowerCase()] || 10;

        if (currentActive >= maxLimit) {
            // "Nepavyko atstatyti! Planas: X, Esami: Y"
            alert(`${t('restore_limit_error')} (${maxLimit})`);
            return;
        }

        // "Ar tikrai norite grąžinti [Vardas] į aktyvų sąrašą?"
        if(!window.confirm(`${t('restore_confirm')} ${worker.name}?`)) return;

        await updateDoc(doc(db, "workers", worker.id), { 
            archived: false,
            archivedAt: null
        });

    } catch (e) {
        console.error(e);
        alert(t('error_generic') + ": " + e.message);
    }
  };

  // --- IŠTRINTI VISAM LAIKUI ---
  const handlePermanentDelete = async (id) => {
      // "DĖMESIO! Tai ištrins darbuotoją negrįžtamai."
      if(!window.confirm(t('delete_permanent_confirm'))) return;
      try {
        await deleteDoc(doc(db, "workers", id));
      } catch (e) {
          alert(t('error_generic') + ": " + e.message);
      }
  };

  if (loading) return <div className="loading-scr">{t('loading')}</div>;

  return (
    <div className="admin-workers-root">
      <button className="gold-back-btn" onClick={() => navigate('/admin/workers')}>
          <ArrowLeft size={18} style={{ marginRight: '8px' }} /> {t('back_to_list')}
      </button>

      <div className="main-content-wrapper">
        <div className="main-wrapper-1280">
            <img src={bfLogo} alt="logo" className="logo-top" style={{opacity: 0.5}} />
            <h1 className="title-top" style={{color: '#94a3b8'}}>{t('archive')}</h1>
            
            <div style={{textAlign: 'center', marginBottom: '30px', color: '#64748b'}}>
                {t('archive_description')}
            </div>

            <div className="worker-header-line" style={{opacity: 0.6}}>
                <div className="c-id">#</div>
                <div className="c-name-header">{t('name')}</div>
                <div className="c-mail">{t('email')}</div>
                <div className="c-phone">{t('phone')}</div>
                <div className="c-acts">{t('actions')}</div>
            </div>

            <div className="worker-rows-scroll-list">
                {archivedWorkers.length === 0 ? (
                    <div style={{color: '#475569', textAlign: 'center', marginTop: '50px', fontSize: '18px'}}>
                        {t('archive_empty')}
                    </div>
                ) : (
                    archivedWorkers.map((w, i) => (
                        <div key={w.id} className="worker-item-row" style={{borderColor: '#334155'}}>
                            <div className="c-id val-gray">{i + 1}</div>
                            <div className="c-name val-gray" style={{textDecoration: 'line-through'}}>{w.name}</div>
                            <div className="c-mail val-gray">{w.email}</div>
                            <div className="c-phone val-gray">{w.phone || "-"}</div>
                            <div className="c-acts">
                                <div className="action-row-flex">
                                    <button className="btn-act info" onClick={() => { setSelectedWorker(w); setShowInfo(true); }} title={t('info')}>
                                        <Info size={18} />
                                    </button>

                                    <button 
                                        className="btn-act" 
                                        style={{color: '#00ff88', borderColor: '#00ff88', background: 'rgba(0, 255, 136, 0.1)'}} 
                                        onClick={() => handleRestore(w)} 
                                        title={t('restore')}
                                    >
                                        <RefreshCw size={18} />
                                    </button>
                                    
                                    <button 
                                        className="btn-act" 
                                        style={{color: '#ff4444', borderColor: '#ff4444', background: 'rgba(255, 68, 68, 0.1)'}} 
                                        onClick={() => handlePermanentDelete(w.id)} 
                                        title={t('delete_permanently')}
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
      </div>

      {showInfo && <WorkerInfoModal worker={selectedWorker} onClose={() => setShowInfo(false)} />}
    </div>
  );
}